export interface StatusBadgeProps {
  badgeContent: string
  type?: 'default' | 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'
}
